import React, { Component } from 'react';
import NavBar from '../../components/nav/NavBar';
import Footer from '../../components/footer/Footer.jsx';
import Images from '../../components/media/Images';
import Videos from '../../components/media/Videos';
import Loader from 'react-loader-spinner';
import { headers, api_url } from '../../common/config';
import windowSize from 'react-window-size';
import { withTranslation } from 'react-i18next';
import i18next from 'i18next';
import FooterHover from '../../components/footer/FooterHover';
class Media extends Component {
    constructor(props) {
        super(props);

        this.state = {
            images: null,
            videos: null,
            width: this.props.windowWidth,
            height: this.props.windowHeight,
        };
    }

    updateDimensions = () => {
        this.setState({ width: window.innerWidth, height: window.innerHeight });
    };

    async componentDidMount() {
        window.addEventListener('resize', this.updateDimensions);
        if (i18next.language === 'ar') {
            document.getElementsByTagName('html')[0].setAttribute('lang', 'ar');
            document.getElementsByTagName('html')[0].setAttribute('dir', 'rtl');
            document.getElementById('root').style.textAlign = 'right';
            document.getElementById('root').dir = 'rtl';
        } else if (i18next.language === 'en') {
            document.getElementsByTagName('html')[0].setAttribute('lang', 'en');
            document.getElementsByTagName('html')[0].setAttribute('dir', 'ltr');
            document.getElementById('root').style.textAlign = 'left';
            document.getElementById('root').dir = 'ltr';
        }

        await fetch(
            `${api_url}/autism/items/news_page_pictures?filter[status]=published&fields=*.*`,
            {
                method: 'GET',
                // headers: headers,
            }
        )
            .then((res) => res.json())
            .then((res) => {
                this.setState({
                    images: res.data,
                });
            });

        await fetch(
            `${api_url}/autism/items/news_page_videos?filter[status]=published&fields=*.*`,
            {
                method: 'GET',
                // headers: headers,
            }
        )
            .then((res) => res.json())
            .then((res) => {
                this.setState({
                    videos: res.data,
                });
            });
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.updateDimensions);
    }

    render() {
        const { t } = this.props;
        return (
            <div className='media-container'>
                <NavBar
                    big
                    media
                    width={this.state.width}
                    height={this.state.height}
                />
                <div
                    className={`media-header ${
                        i18next.language === 'en' ? 'text-left' : ''
                    }`}
                >
                    <h1>{t('media.title')}</h1>
                </div>
                {this.state.images === null && this.state.videos === null ? (
                    <div className='media-loader'>
                        <Loader
                            type='Grid'
                            color='#fff'
                            height={100}
                            width={100}
                            timeout={15000} //5 secs
                        />
                    </div>
                ) : (
                    <>
                        {this.state.images.length === 0 ? (
                            <></>
                        ) : (
                            <div className='media-images'>
                                <Images />
                            </div>
                        )}
                        {this.state.videos === 0 ? (
                            <></>
                        ) : (
                            <div className='media-videos'>
                                <Videos />
                            </div>
                        )}
                    </>
                )}
                <FooterHover white />
                <div className='media-footer'>
                    <Footer />
                </div>
            </div>
        );
    }
}

export default withTranslation()(windowSize(Media));
